const KEY = "life_rabbit_hole_state_v1";

export const loadState = () => {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
};

export const saveState = (state) => {
  try {
    localStorage.setItem(KEY, JSON.stringify(state));
  } catch {
    // ignore
  }
};

export const updateState = (patch) => {
  const s = loadState();
  const next = { ...s, ...patch };
  saveState(next);
  return next;
};
